import React, {Component, ReactElement} from 'react'
import PreformattedDiv from '../../../styledComponents/PreformattedDiv'
import {Messages} from '../../../Messages'
import {Nullable} from '../../../app/TypeHelpers'
import {MainContainer} from '../../../styledComponents/ContentsArea'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import styled from 'styled-components'
import NotInterestedIcon from '@mui/icons-material/NotInterested'
import {AdminDefaultButton} from '../../../styledComponents/adminPage/Buttons'
import {Colors} from '../../../styledComponents/Constants'
import withStyles from '@mui/styles/withStyles'
import {AppAdminContext} from '../../../app/AppAdminContext'
import {Location} from 'react-router-dom'
import {getQueryParameter} from '../../common/util/Natutil';

interface Props {
    location: Location
}

interface State {
    message: string
}

class NatAdminSystemErrorPage extends Component<Props & AdminPagePropsSet, State> {
    declare context: React.ContextType<typeof AppAdminContext>
    constructor(props: Readonly<Props & AdminPagePropsSet>) {
        super(props)

        // デフォルトメッセージの設定
        let message = Messages.ESYCC0015.toString()
        const messageId: string = getQueryParameter('messageId', this.props.location.search);
        if (messageId && messageId in Messages) {
            const key = messageId as keyof typeof Messages;
            message = Messages[key].toString();
        } else if (this.props.location.state && this.props.location.state.message) {
            // 遷移元から指定されたメッセージがあれば、設定
            message = this.props.location.state.message
        }

        this.state = {
            message: message,
        }
    }

    render(): Nullable<ReactElement> {
        const spMode = this.context.showSpModePage
        return (
            <>
                <ErrorTitleArea>
                    <StyledNotInterestedIcon/>
                    <ErrorTitle>
                        アクセスしようとしたページは表示できませんでした。
                    </ErrorTitle>
                </ErrorTitleArea>
                <StyledMainContainer $spMode={spMode}>
                    <PreformattedDiv>{this.state.message}</PreformattedDiv>
                </StyledMainContainer>
                <ButtonArea $spMode={spMode}>
                    <AdminDefaultButton
                        fullWidth={spMode}
                        onClick={() => this.props.navigate(
                            '/admin/login-portal',
                        )}
                    >
                        ログイン画面へ戻る
                    </AdminDefaultButton>
                </ButtonArea>
            </>
        )
    }
}

NatAdminSystemErrorPage.contextType = AppAdminContext
export default createAdminPage(NatAdminSystemErrorPage)

const ErrorTitleArea = styled.div`
  margin-top: 9px;
  display: flex;
  align-items: center;
`

const StyledNotInterestedIcon = withStyles({
    root: {
        fontSize: '48px',
        color: '#b0b0b0',
    },
})(NotInterestedIcon)

const ErrorTitle = styled.div`
  margin-left: 8px;
  font-size: 20px;
  font-weight: bold;
  color: ${Colors.AccentDark};
`

const StyledMainContainer = styled(MainContainer)<{ $spMode: boolean }>`
  margin-top: 32px;
  ${props => props.$spMode && `
    margin-left: -15px;
    margin-right: -15px;
  `}
`

const ButtonArea = styled.div<{ $spMode: boolean }>`
  ${props => props.$spMode ? `
    margin-top: 40px;
  ` : `
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  `}
`
